import { UserStation } from './UserStation';
export class User {
  uid: string;
  name: string;
  icNumber: string;
  timestamp?: Date;
  contactNumber?: string;
  email?: string;
  healthStatus?: string = 'green';
  verificationStatus?: string;
  icImageUrl?: string;
  selfieImageUrl?: string;
  address?: string;
  postcode?: string;
  state?: string;
  temperature?: string;

  constructor(
    uid: string,
    name: string,
    icNumber: string,
    contactNumber?: string,
    email?: string,
    timestamp?: Date,
    temperature?: string,
    healthStatus?: string,
    verificationStatus?: string,
    icImageUrl?: string,
    selfieImageUrl?: string,
    address?: string,
    postcode?: string,
    state?: string
  ) {
    this.uid = uid;
    this.name = name;
    this.icNumber = icNumber;
    this.timestamp = timestamp;
    this.contactNumber = contactNumber;
    this.email = email;
    this.healthStatus = healthStatus;
    this.verificationStatus = verificationStatus;
    this.icImageUrl = icImageUrl;
    this.selfieImageUrl = selfieImageUrl;
    this.address = address;
    this.postcode = postcode;
    this.state = state;
    this.temperature = temperature;
  }
}
